import createReactComponent from '../createReactComponent';
export default createReactComponent('player-play', 'IconPlayerPlay', [
  ['path', { d: 'M7 4v16l13 -8z', key: 'svg-0' }],
]);
